// responsible for sending and listening to midi cc events
import {setLastMidiCCPlayed} from 'actions/index.js';

class MidiCC {
    constructor(sequencerEngine) {
        this.sequencerEngine = sequencerEngine;
        this.ccToCallback = {};
        this.callbacks = [];
    }

    setCallback(ccNumber, callback) {
        this.ccToCallback[ccNumber] = callback;
    }

    send(ccNumber, value) {
        value = Math.round(value);
        if (value < 0) {
            value = 0;
        } else if (value > 127) {
            value = 127;
        }
        this.output.sendControlChange(ccNumber, value);
    }

    onEvent(event) {
        let callback = this.ccToCallback[event.controller.number];
        if (callback) {
            callback(event.value);
        }

        if (event.controller.number !== 38 && event.controller.number !== 6 &&
           event.controller.number !== 96 && event.controller.number !== 97) {
            this.sequencerEngine.store.dispatch(
                setLastMidiCCPlayed({number: event.controller.number, value: event.value}));
        }
    }
}

export default MidiCC;
